{
  "login": {
    "title": "Մուտք գործեք ձեր հաշիվ",
    "emailLabel": "Էլ. հասցե",
    "emailPlaceholder": "դուք@example.com",
    "passwordLabel": "Գաղտնաբառ",
    "passwordPlaceholder": "••••••••",
    "forgotPassword": "Մոռացե՞լ եք գաղտնաբառը:",
    "submit": "Մուտք",
    "submitting": "Մուտք գործում…",
    "errors": {
      "invalidCredentials": "Սխալ տվյալներ: Ստուգեք էլ. հասցեն և գաղտնաբառը:",
      "accountInactive": "Ձեր հաշիվը ոչ ակտիվ է: Դիմեք ձեր ադմինիստրատորին:",
      "unexpected": "Անսպասելի սխալ է տեղի ունեցել: Խնդրում ենք կրկին փորձել:"
    }
  },
  "forgotPassword": {
    "title": "Վերականգնել գաղտնաբառը",
    "successTitle": "Ստուգեք ձեր էլ. փոստը",
    "description": "Մուտքագրեք ձեր էլ. հասցեն, և մենք կուղարկենք գաղտնաբառի վերականգնման հղում:",
    "emailLabel": "Էլ. հասցե",
    "submit": "Ուղարկել հղումը",
    "submitting": "Ուղարկվում է…",
    "backToSignIn": "Վերադառնալ մուտք",
    "genericError": "Ինչ-որ բան սխալ գնաց: Խնդրում ենք կրկին փորձել:",
    "successMessage": "Եթե {{email}} հասցեով հաշիվ գոյություն ունի, շուտով կստանաք գաղտնաբառի վերականգնման հղում:"
  },
  "resetPassword": {
    "title": "Սահմանեք նոր գաղտնաբառ",
    "newPasswordLabel": "Նոր գաղտնաբառ",
    "confirmPasswordLabel": "Հաստատեք նոր գաղտնաբառը",
    "submit": "Վերականգնել գաղտնաբառը",
    "submitting": "Վերականգնվում է…",
    "errors": {
      "passwordMismatch": "Գաղտնաբառերը չեն համընկնում:",
      "invalidLink": "Հղումն անվավեր է կամ ժամկետանց: Խնդրում ենք նորը պահանջել:",
      "expiredLink": "Այս հղումն անվավեր է կամ ժամկետանց:",
      "requestNewLink": "Պահանջել նոր հղում"
    },
    "success": "Գաղտնաբառը հաջողությամբ վերականգնվեց: Խնդրում ենք մուտք գործել:"
  },
  "changePassword": {
    "title": "Փոխել գաղտնաբառը",
    "currentPasswordLabel": "Ընթացիկ գաղտնաբառ",
    "newPasswordLabel": "Նոր գաղտնաբառ",
    "confirmPasswordLabel": "Հաստատեք նոր գաղտնաբառը",
    "newPasswordPlaceholder": "Նվազ. 8 նիշ",
    "confirmPasswordPlaceholder": "Նվազ. 8 նիշ",
    "submit": "Փոխել գաղտնաբառը",
    "submitting": "Պահպանվում է…",
    "errors": {
      "currentPasswordIncorrect": "Ընթացիկ գաղտնաբառը սխալ է:",
      "tooShort": "Նոր գաղտնաբառը պետք է լինի առնվազն 8 նիշ:",
      "passwordMismatch": "Գաղտնաբառերը չեն համընկնում:",
      "genericFailed": "Չհաջողվեց փոխել գաղտնաբառը: Խնդրում ենք կրկին փորձել:"
    },
    "success": "Գաղտնաբառը հաջողությամբ փոխվեց:"
  }
}
